import React from "react";
import styles from "./styles.module.scss";
import spareImg from "../../../shared/images/spare.svg";

const TableFrame = (props) => {
  const { players, showLow, tableStyles, title = "" } = props;
  const squares = new Array(12).fill("");

  const isSplit = (pin) => {
    return Math.floor(pin / 1024) === 1;
  };

  const {
    background: evenBackground,
    color: evenColor,
    fontSize: evenFontSize,
    fontWeight: evenFontWeight,
  } = tableStyles.evenRows;

  const {
    background: oddBackground,
    color: oddColor,
    fontSize: oddFontSize,
    fontWeight: oddFontWeight,
  } = tableStyles.oddRows;

  const {
    background: scoreBackground,
    color: scoreColor,
    fontSize: scoreFontSize,
    fontWeight: scoreFontWeight,
  } = tableStyles.maxScore;

  const {
    background: frameContainerBackground,
    color: frameContainerColor,
    fontSize: frameContainerFontSize,
    fontWeight: frameContainerFontWeight,
  } = tableStyles.frameContainer;

  const someStyle = {
    "--evenBackground": evenBackground,
    "--evenColor": evenColor,
    "--evenFontSize": evenFontSize,
    "--evenFontWeight": evenFontWeight,
    "--oddBackground": oddBackground,
    "--oddColor": oddColor,
    "--oddFontSize": oddFontSize,
    "--oddFontWeight": oddFontWeight,
    "--scoreBackground": scoreBackground,
    "--scoreColor": scoreColor,
    "--scoreFontSize": scoreFontSize,
    "--scoreFontWeight": scoreFontWeight,
    "--frameContainerBackground": frameContainerBackground,
    "--frameContainerColor": frameContainerColor,
    "--frameContainerFontSize": frameContainerFontSize,
    "--frameContainerFontWeight": frameContainerFontWeight,
    "--sectionContainerBackground": tableStyles.sectionContainerBackground,
  };

  return (
    <div className={styles.containerTable} style={someStyle}>
      {title && <div className={styles.title}>{title}</div>}
      {players && players.length ? (
        <div className={styles.bodyTable}>
          <div className={styles.turns}>
            <span className={styles.turn} style={someStyle}>
              Player
            </span>
            {squares.map((e, index) => (
              <span className={styles.turn} style={someStyle} key={index}>
                {index < 9 ? index + 1 : index === 10 ? 10 : ""}
              </span>
            ))}
            <span className={styles.turn} style={someStyle}>
              Max Score
            </span>
          </div>
          {players.map((laneThrow, index) => {
            return (
              <div className={styles.players} key={index} style={someStyle}>
                <div className={styles.squares}>
                  <span className={`${styles.square}`} style={someStyle}>
                    {laneThrow.displayName}
                  </span>
                  {squares.map((e, index) => (
                    <span
                      className={`${styles.square} ${
                        laneThrow.throws &&
                        laneThrow.throws.length > index * 2 &&
                        styles.past
                      } ${styles.active}`}
                      style={someStyle}
                      key={index}
                    >
                      {(laneThrow.throws &&
                        laneThrow.throws.length &&
                        laneThrow.throws[index * 2] &&
                        laneThrow.throws[index * 2] !== "X" &&
                        index < 9 && (
                          <span className={styles.numbers}>
                            <span
                              className={`${styles.number} ${
                                isSplit(laneThrow.pins[index * 2]) &&
                                styles.split
                              }`}
                            >
                              {laneThrow.throws[index * 2]}
                            </span>
                            {laneThrow.throws[index * 2 + 1] !== "/" && (
                              <span
                                className={`${styles.number} ${
                                  isSplit(laneThrow.pins[index * 2 + 1]) &&
                                  styles.split
                                }`}
                              >
                                {laneThrow.throws[index * 2 + 1]}
                              </span>
                            )}
                            {laneThrow.throws[index * 2 + 1] === "/" && (
                              <span className={styles.number}>
                                <img src={spareImg} alt="" />
                              </span>
                            )}
                          </span>
                        )) ||
                        ""}
                      {(index > 8 && (
                        <div>
                          {laneThrow.throws &&
                            laneThrow.throws[index * 2] !== "/" &&
                            laneThrow.throws[index * 2] !== "X" && (
                              <span
                                className={`${styles.number} ${styles.fixTop} ${
                                  isSplit(laneThrow.pins[index * 2]) &&
                                  styles.split
                                }`}
                              >
                                {laneThrow.throws[index * 2]}
                              </span>
                            )}
                          {laneThrow.throws &&
                            laneThrow.throws[index * 2] === "/" &&
                            laneThrow.throws[index * 2] !== "X" && (
                              <span className={`${styles.number}`}>
                                <img src={spareImg} alt="" />
                              </span>
                            )}
                        </div>
                      )) ||
                        ""}
                      {(laneThrow.throws &&
                        laneThrow.throws.length &&
                        laneThrow.throws[index * 2] &&
                        laneThrow.throws[index * 2] === "X" && (
                          <span className={styles.strike}>X</span>
                        )) ||
                        ""}
                    </span>
                  ))}
                  <span className={styles.square} style={someStyle}>
                    {!props.showLow && laneThrow.maxScore}
                  </span>
                </div>
                {showLow && (
                  <div className={styles.squares}>
                    <span className={styles.square} style={someStyle}></span>
                    {squares.map((s, index) => (
                      <span
                        className={`${styles.square} ${styles.score} ${
                          (laneThrow.throws.length > index * 2 ||
                            laneThrow.scores.length > 9) &&
                          styles.past
                        } `}
                        style={{
                          borderRight:
                            (index === 9 || index === 10) &&
                            "1px solid transparent",
                          ...someStyle,
                        }}
                        key={index}
                      >
                        <span className={styles.numbers}>
                          <span className={styles.scoreNumber}>
                            {index !== 9 && index !== 11
                              ? index === 10
                                ? laneThrow.scores[index - 1]
                                : laneThrow.scores[index]
                              : ""}
                          </span>
                        </span>
                      </span>
                    ))}
                    <span className={styles.square} style={someStyle}>
                      {laneThrow.maxScore}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div>There are no players</div>
      )}
    </div>
  );
};

export default TableFrame;
